// assets
import {
  UserOutlined,
  EnvironmentOutlined,
  TeamOutlined,
  BankOutlined,
  DollarCircleOutlined
} from '@ant-design/icons';

// icons
const icons = {
  UserOutlined,
  EnvironmentOutlined,
  TeamOutlined,
  BankOutlined,
  DollarCircleOutlined
};

// ==============================|| MENU ITEMS - BASE DE DATOS ||============================== //

const pages = {
  id: 'base-datos',
  title: 'Base de Datos',
  type: 'group',
  children: [
    {
      id: 'bancos',
      title: 'Bancos',
      type: 'item',
      url: '/bancos',
      icon: icons.BankOutlined
    },
    {
      id: 'distritos',
      title: 'Distritos',
      type: 'item',
      url: '/distritos',
      icon: icons.EnvironmentOutlined
    },
    {
      id: 'socios',
      title: 'Socios',
      type: 'item',
      url: '/socios',
      icon: icons.TeamOutlined
    },
    {
      id: 'tiposcreditos',
      title: 'Tipos de Créditos',
      type: 'item',
      url: '/tipos_creditos',
      icon: icons.DollarCircleOutlined
    },
    {
      id: 'usuarios',
      title: 'Usuarios',
      type: 'item',
      url: '/usuarios',
      icon: icons.UserOutlined
    },
    {
      id: 'parentesco',
      title: 'Parentescos',
      type: 'item',
      url: '/parentescos',
      icon: icons.UserOutlined
    },
    {
      id: 'pausas',
      title: 'Pausas',
      type: 'item',
      url: '/pausas',
      icon: icons.UserOutlined
    },
    {
      id: 'beneficiarios',
      title: 'Beneficiarios',
      type: 'item',
      url: '/beneficiarios',
      icon: icons.UserOutlined
    },
    {
      id: 'beneficiarios-categoria',
      title: 'Beneficiarios Categorías',
      type: 'item',
      url: '/beneficiarioscategoria',
      icon: icons.UserOutlined
    },
    {
      id: 'motivocreditos',
      title: 'Motivos Creditos',
      type: 'item',
      url: '/motivoscreditos',
      icon: icons.UserOutlined
    },
    {
      id: 'cuentas',
      title: 'Plan de Cuentas',
      type: 'item',
      url: '/cuentas',
      icon: icons.UserOutlined
    },
    {
      id: 'creditos',
      title: 'Créditos ',
      type: 'item',
      url: '/creditos',
      icon: icons.UserOutlined
    }
  ]
};

export default pages;
